export function filterNftCacheService(services) {
    const idFragments = ["privateRemoteProfile"];
    return services.filter((s) => s.id.split("#").length > 1 &&
        idFragments.includes(s.id.split("#")[1]) &&
        s.type === "DataStore");
}
